const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`1b4df325eabf7e60874e5d02caa607ed81214d00dd85534049e5b96b35f4f5d4`, `1b4df325eabf7e60874e5d02caa607ed81214d00dd85534049e5b96b35f4f5d4`, 1, 123), undefined, true, false, 1));
            }

            getTemplateName() {
                return `1b4df325eabf7e60874e5d02caa607ed81214d00dd85534049e5b96b35f4f5d4`;
            }

            getSourceContext() {
                return new this.Source(``, `1b4df325eabf7e60874e5d02caa607ed81214d00dd85534049e5b96b35f4f5d4`, ``);
            }
        }],
        [123, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/list/list.twig`, `1b4df325eabf7e60874e5d02caa607ed81214d00dd85534049e5b96b35f4f5d4`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/list/list.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.env.getFilter('slice').traceableCallable(3, this.source)(...[this.env, (context.has(`topics`) ? context.get(`topics`) : null), 0, 10]));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`topic`] = __value__;
                    this.echo(`      <li>
        `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/dot-leader/dot-leader.twig`, new Map([[`label`, this.traceableMethod(this.getAttribute, 6, this.source)(this.env, context.get(`topic`), `title`, new Map([]), `any`, false, false, false)], [`count`, this.traceableMethod(this.getAttribute, 7, this.source)(this.env, context.get(`topic`), `count`, new Map([]), `any`, false, false, false)], [`href`, `https://cloudfour.com/thinks/`]]), false, false, 5));
                    this.echo(`      </li>
    `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('topic');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`  `);
            }

            getTemplateName() {
                return `1b4df325eabf7e60874e5d02caa607ed81214d00dd85534049e5b96b35f4f5d4`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `1b4df325eabf7e60874e5d02caa607ed81214d00dd85534049e5b96b35f4f5d4`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '1b4df325eabf7e60874e5d02caa607ed81214d00dd85534049e5b96b35f4f5d4');

let template = env.loadTemplate('1b4df325eabf7e60874e5d02caa607ed81214d00dd85534049e5b96b35f4f5d4');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/dot-leader/demo/list.twig", args: context }
     );
     return rendered;;
};